// src/components/alerts/AlertItem.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Trash2, Mail, MailOpen, AlertTriangle, Bell } from "lucide-react";

const AlertItem = ({ alert, onRead, onDelete }) => {
  const doc = alert.document;
  const isRead = alert.is_read;
  const hasDoc = !!doc;

  // 📌 문서 알림: 문서 상세로 이동
  // 📌 프로젝트 자료실 알림: 프로젝트 공유 자료실 페이지로 이동
  const targetUrl = hasDoc
    ? `/project/${doc.project}/${doc.module}/${doc.doc_type}/${doc.dns}/view`
    : alert.project
      ? `/project/${alert.project}/docs/data`
      : "#";

  // 긴급/일반 아이콘
  const statusIcon = alert.is_urgent ? (
    <div className="p-2 rounded-lg bg-red-50 border border-red-100">
      <AlertTriangle size={18} className="text-red-600" />
    </div>
  ) : (
    <div className="p-2 rounded-lg bg-blue-50 border border-blue-100">
      <Bell size={18} className="text-blue-600" />
    </div>
  );

  return (
    <li className="w-full">
      <Link
        to={targetUrl}
        className={`
          block w-full transition-all alert-item-hover
          ${isRead ? "bg-white hover:bg-gray-50" : "bg-blue-50/60 hover:bg-blue-100/60"}
          ${alert.is_urgent && !isRead ? "border-l-4 border-red-400" : ""}
        `}
        onClick={() => {
          if (!alert.is_read) onRead(alert.id);
        }}
      >
        <div className="p-4 flex gap-3 items-start">
          {/* 상태 아이콘 */}
          <div className="shrink-0">{statusIcon}</div>

          {/* 본문 */}
          <div className="flex-1 min-w-0 space-y-2">
            <div
              className={`text-sm font-bold leading-snug ${isRead ? "text-gray-600" : "text-gray-900"
                }`}
            >
              {alert.message}
            </div>

            <div className="flex items-center gap-2 text-xs text-gray-600 min-w-0">
              {hasDoc ? (
                <>
                  <span className="inline-flex items-center px-2 py-1 rounded-md bg-white border border-gray-200 text-[11px] font-semibold whitespace-nowrap shadow-sm">
                    {(doc.doc_type || "").toUpperCase()}
                  </span>
                  <span className="truncate flex-1 font-medium">{doc.title}</span>
                </>
              ) : (
                <span className="truncate flex-1 font-medium">프로젝트 공유 자료실</span>
              )}
            </div>
          </div>

          {/* 시간 / 액션 */}
          <div className="flex flex-col items-end gap-2 shrink-0">
            <div className="text-[11px] text-gray-500 text-right font-medium">
              <div>{alert.created_at.split(" ")[0]}</div>
              <div>{alert.created_at.split(" ")[1]}</div>
            </div>
            <div className="flex items-center gap-1">
              <button
                className="p-1.5 rounded-md hover:bg-blue-100 border border-transparent hover:border-blue-300 transition-all"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onRead(alert.id);
                }}
                title={alert.is_read ? "읽음" : "읽음 표시"}
              >
                {alert.is_read ? (
                  <MailOpen size={15} className="text-green-600" />
                ) : (
                  <Mail size={15} className="text-blue-600" />
                )}
              </button>
              <button
                className="p-1.5 rounded-md hover:bg-red-100 border border-transparent hover:border-red-300 transition-all"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onDelete(alert.id);
                }}
                title="삭제"
              >
                <Trash2 size={15} className="text-red-600" />
              </button>
            </div>
          </div>
        </div>
      </Link>
    </li>
  );
};

export default AlertItem;
